// extracted by mini-css-extract-plugin
export var brand = "_bu-9";
export var compact = "_bu-6";
export var extraSmall = "_bu-7";
export var icon = "_bu-0";
export var large = "_bu-4";
export var light = "_bu-1";
export var medium = "_bu-5";
export var outline = "_bu-b";
export var primaryDark = "_bu-a";
export var primaryLight = "_bu-8";
export var primaryModern = "_bu-c";
export var success = "_bu-2";
export var successSolid = "_bu-3";